/**
 * أيقونات الواجهة: رسوم SVG مكتوبة هنا بخط واحد (stroke) على شبكة 24 — لا مكتبة خارجية
 * ولا خط أيقونات، فلا طلب شبكة (CSP: ‎font-src 'self'‎) ولا اختلاف بين أنظمة التشغيل
 * كما مع الرموز النصية ⚙ ▲ ✓. اللون من `currentColor` فتتبع النص فى الوضعين.
 */
const PATHS = {
  home: 'M3 10.5 12 3l9 7.5M5.5 8.5V20h13V8.5M9.5 20v-6h5v6',
  journal: 'M6 3h10l3 3v15H6zM9 8h7M9 12h7M9 16h4',
  ledger: 'M4 4h16v16H4zM4 9h16M10 9v11',
  calendar: 'M4 6h16v14H4zM4 10h16M8 3v5M16 3v5',
  chart: 'M4 20V10M10 20V4M16 20v-7M22 20H2',
  reports: 'M14 3H6v18h12V7zM14 3v4h4M9 17v-3M12 17v-6M15 17v-2',
  users:
    'M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM2.5 20c.8-3.5 3.4-5.5 6.5-5.5s5.7 2 6.5 5.5M16 4.5a3.5 3.5 0 0 1 0 6.5M18.5 14.8c1.6.8 2.6 2.6 3 5.2',
  invoice: 'M6 3h12v18l-3-2-3 2-3-2-3 2zM9 8h6M9 12h6M9 16h3',
  receive: 'M12 3v11M7.5 9.5 12 14l4.5-4.5M4 15v5h16v-5',
  tag: 'M3 12V4h8l10 10-8 8zM7.5 8.5h.01',
  box: 'M3 7.5 12 3l9 4.5v9L12 21l-9-4.5zM3 7.5l9 4.5 9-4.5M12 12v9',
  truck:
    'M2 6h12v10H2zM14 10h4l3 3v3h-7M6 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM17 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4z',
  bill: 'M5 3h14v18H5zM9 7h6M9 11h6M9 15h6',
  send: 'M12 21V10M7.5 14.5 12 10l4.5 4.5M4 9V4h16v5',
  wallet: 'M3 7h16a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H3zM3 7l12-4v4M16 13.5h.01',
  expense:
    'M12 3v18M16.5 7.5c0-1.7-2-3-4.5-3s-4.5 1.3-4.5 3 2 2.8 4.5 3.5 4.5 1.8 4.5 3.5-2 3-4.5 3-4.5-1.3-4.5-3',
  bank: 'M3 9.5 12 4l9 5.5M5 10v8M9.5 10v8M14.5 10v8M19 10v8M3 20h18',
  reconcile: 'M4 7h13l-3-3M20 17H7l3 3',
  settings:
    'M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM19.4 13.5l1.6 1.2-2 3.4-1.9-.7a7.6 7.6 0 0 1-2.2 1.3l-.3 2h-4l-.3-2a7.6 7.6 0 0 1-2.2-1.3l-1.9.7-2-3.4 1.6-1.2a7.7 7.7 0 0 1 0-3l-1.6-1.2 2-3.4 1.9.7a7.6 7.6 0 0 1 2.2-1.3l.3-2h4l.3 2a7.6 7.6 0 0 1 2.2 1.3l1.9-.7 2 3.4-1.6 1.2a7.7 7.7 0 0 1 0 3z',
  platform: 'M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z',
  sun: 'M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4',
  moon: 'M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5z',
  auto: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 3v18',
  menu: 'M4 7h16M4 12h16M4 17h16',
  close: 'M6 6l12 12M18 6 6 18',
  logout: 'M10 4H4v16h6M15 8l-4 4 4 4M11 12h10',
  check: 'M4.5 12.5 9.5 17.5 19.5 7',
  alert: 'M12 3 2 20h20zM12 10v4.5M12 17.5h.01',
  help: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM9.5 9.5a2.5 2.5 0 1 1 3.4 2.3c-.6.3-.9.8-.9 1.4v.6M12 16.8h.01',
  info: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 11v6M12 7.5h.01',
  lock: 'M5 11h14v10H5zM8 11V7.5a4 4 0 0 1 8 0V11',
  plus: 'M12 5v14M5 12h14',
  sparkle:
    'M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8zM19 16l.8 2.2L22 19l-2.2.8L19 22l-.8-2.2L16 19l2.2-.8z',
  arrowUp: 'M12 19V5M6 11l6-6 6 6',
  arrowDown: 'M12 5v14M6 13l6 6 6-6',
  chevron: 'M15 5l-7 7 7 7',
  empty: 'M3 13h5l1.5 3h5L16 13h5M5.5 5h13L21 13v6H3v-6z',
  refresh: 'M20 11a8 8 0 0 0-14.5-4.5L4 8M4 4v4h4M4 13a8 8 0 0 0 14.5 4.5L20 16M20 20v-4h-4',
} as const;

export type IconName = keyof typeof PATHS;

export const ICON_NAMES = Object.keys(PATHS) as IconName[];

export function Icon({
  name,
  size = 20,
  className,
  label,
}: {
  name: IconName;
  size?: number;
  className?: string;
  /** بلا `label` الأيقونة زخرفة يتجاهلها قارئ الشاشة — النص المجاور يحمل المعنى. */
  label?: string;
}) {
  return (
    <svg
      className={'icon' + (className ? ' ' + className : '')}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      focusable="false"
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
